import { ErrorMessage } from "@hookform/error-message";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import "react-medium-image-zoom/dist/styles.css";
import { NumericFormat } from "react-number-format";
import { useHistory, useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { InputGroup, InputGroupAddon } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
  RSelect,
} from "../../../components/Component";
import { GET, POST, PUT } from "../../../helper/api";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { BILL_STATUS, BILL_TYPE, getDefaultPnBill, INGREDIENT_GROUP, randomString, TRUCK_TYPE } from "../../../utils/Utils";

const BILL_STATUS_OPTIONS = Object.keys(BILL_STATUS).map((c) => ({
  label: BILL_STATUS[c],
  value: c,
}));

const BILL_TYPE_OPTIONS = Object.keys(BILL_TYPE).filter(e => e !== 'SERVICE').map((c) => ({
  label: BILL_TYPE[c],
  value: c,
}));


const PnBillStaffMoneyFlow = () => {
  const history = useHistory();
  const { search } = useLocation();
  const duplicateId = new URLSearchParams(search).get("duplicateId");
  const params = useParams();
  const id = duplicateId || params.id;
  const isEdit = params.id && !duplicateId;
  const methodForm = useForm({
    defaultValues: {
      ...getDefaultPnBill(),
      debtUserType: 'IN'
    },
    shouldFocusError: true,

  });
  const {
    errors,
    register,
    handleSubmit,
    reset,
    getValues,
    control,
    setValue,
    watch,
  } = methodForm;
  const [loading, setLoading] = useState(false);

  const [smOption, setSmOption] = useState(false);
  const [userOptions, setUserOptions] = useState([]);
  const [truckOptions, setTruckOptions] = useState([]);
  const [ingredientOptions, setIngredientOptions] = useState([]);

  const debtUserType = watch("debtUserType");

  useEffect(() => {
    GET(`/ingredient`, {}, true)
      .then(({ data }) => {
        setIngredientOptions(data.rows.filter(c => [INGREDIENT_GROUP.STAFF, INGREDIENT_GROUP.STAFF_OUT].includes(c.group)).map(c => ({
          label: `${c.name}`,
          value: c.id,
          data: c
        })))
      })

    GET("truck", {
      type: TRUCK_TYPE.TRUCK
    }, true).then((resp) => {
      const { data } = resp;
      if (data && data.rows && data.rows.length) {
        setTruckOptions(
          data.rows.map((c) => ({
            label: c.id,
            value: c.id,
            data: c,
          }))
        );
      }
    });


    GET("/user", {}, true).then((resp) => {
      const { data } = resp;
      setUserOptions(
        data.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      )
    });
  }, []);

  useEffect(() => {
    if (id) {
      GET(`/pn-bill/${id}`, {}, true)
        .then((resp) => {
          const { data } = resp;
          data.createdAt = moment(data.createdAt).format("YYYY-MM-DD HH:mm:ss");
          if (duplicateId) {
            data.id = `${duplicateId}-${randomString(10)}`
          }
          reset(data);
        })
        .catch((err) => {
          toast.error(err.response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại.");
          history.goBack();
        })

    }
  }, [id]);


  const onHandleSubmit = () => {
    setLoading(true);
    const data = getValues();
    const {
      createdAt,

      debtUserId,
      debtUserType,

      ingredientId,
      truckId,

      deliveryFeeByWeight,
      note,

      status,
      billPictures,
    } = data

    const formData = {
      createdAt,

      debtUserId,
      debtUserType,

      ingredientId,
      truckId,
      finalMerchandiseWeight: 1,

      deliveryFeeByWeight: deliveryFeeByWeight || 0,
      note: note || null,

      status,
      billPictures: billPictures?.map((c) => c.src) || [],
    };

    const request = isEdit
      ? PUT(
        `/pn-bill/update/${id}`,
        formData,
        {},
        true
      )
      : POST(
        `/pn-bill/create/${data.id}`,
        formData,
        {},
        true
      );

    request
      .then((res) => {
        if (id) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        history.goBack();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const randomId = () => {
    const id = `PN-${moment().format("YYYYMMDD")}-${randomString(10)}`;
    setValue("id", id);
  }

  return (
    <React.Fragment>
      <Head title="Đơn phí nhân viên"></Head>

      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Đơn phí nhân viên</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div>
                        <Button
                          color="primary"
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <span>Trở về</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  <FormProvider {...methodForm}>
                    <form>
                      <div className="mb-4">
                        <Row className="g-2">
                          <Col size="4">
                            <div className="form-group">
                              <label className="form-label" htmlFor="customer">
                                Mã đơn <span className="text-danger">*</span>
                              </label>
                              <div className="form-control-wrap">
                                <InputGroup>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="id"
                                    ref={register({
                                      required: "Vui lòng nhập thông tin",
                                    })}
                                    disabled={true}
                                  />
                                  <InputGroupAddon addonType="append">
                                    <Button disabled={!!id} type="button" color="primary" onClick={(e) => {
                                      e?.preventDefault();
                                      randomId();
                                    }}>
                                      <span>Tạo ngẫu nhiên</span>
                                    </Button>
                                  </InputGroupAddon>
                                </InputGroup>


                                <ErrorMessage
                                  errors={errors}
                                  name="id"
                                  render={({ message }) => (
                                    <span className="invalid">{message}</span>
                                  )}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col size="3">
                            <div className="form-group">
                              <label className="form-label" >
                                Thời gian tạo đơn<span className="text-danger">*</span>
                              </label>
                              <div className="form-control-wrap">
                                <input
                                  rows={3}
                                  className="form-control"
                                  type="datetime-local"
                                  name="createdAt"
                                  ref={register({ required: "Vui lòng nhập thông tin" })}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="createdAt"
                                  render={({ message }) => (
                                    <span className="invalid">{message}</span>
                                  )}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                      <Row className="mt-3">
                        <Col size={12}>
                          <BlockTitle tag="h5" className={`text-primary`}>
                            Thông tin đơn hàng
                          </BlockTitle>
                        </Col>

                        <Col size="3">
                          <div className="form-group">
                            <label className="form-label">
                              Nhân viên{` `}<span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="debtUserId"
                                rules={{
                                  required: "Vui lòng nhập thông tin"
                                }}
                                render={({ onChange, value, name, ref }) => (
                                  <RSelect
                                    ref={ref}
                                    name={name}
                                    options={userOptions}
                                    value={
                                      userOptions.find(
                                        (c) => `${c.value}` === `${value}`
                                      ) || null
                                    }
                                    onChange={(val) => {
                                      onChange(val.value)
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="debtUserId"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col size="3">
                          <div className="form-group">
                            <label className="form-label" >
                              Xe tải{` `}<span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="truckId"
                                rules={{
                                  required: "Vui lòng nhập thông tin"
                                }}
                                render={({ onChange, name, value, ref }) => (
                                  <RSelect
                                    ref={ref}
                                    name={name}
                                    options={truckOptions}
                                    value={
                                      truckOptions.find((c) => c.value === value) || null
                                    }
                                    onChange={(val) => {
                                      onChange(val.value);
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="truckId"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col size="3">
                          <div className="form-group">
                            <label className="form-label" >
                              Ghi nhận công nợ cho nhân viên{` `}<span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="debtUserType"
                                rules={{
                                  required: "Vui lòng nhập thông tin"
                                }}
                                render={({ onChange, value, name, ref }) => (
                                  <RSelect
                                    ref={ref}
                                    name={name}
                                    options={BILL_TYPE_OPTIONS}
                                    value={
                                      BILL_TYPE_OPTIONS.find(
                                        (c) => `${c.value}` === `${value}`
                                      ) || null
                                    }
                                    onChange={(val) => {
                                      onChange(val?.value)
                                      setValue('ingredientId', null)
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="debtUserType"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col size="3">
                          <div className="form-group">
                            <label className="form-label" >
                              Nguyên liệu{` `}<span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="ingredientId"
                                rules={{
                                  required: "Vui lòng nhập thông tin"
                                }}
                                render={({ onChange, name, value, ref }) => (
                                  <RSelect
                                    ref={ref}
                                    name={name}
                                    options={ingredientOptions.filter(c => debtUserType === 'IN' ? c.data.group === INGREDIENT_GROUP.STAFF : c.data.group === INGREDIENT_GROUP.STAFF_OUT)}
                                    value={
                                      ingredientOptions.find((c) => c.value === value) || null
                                    }
                                    onChange={(val) => {
                                      onChange(val.value);
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="ingredientId"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col size="3">
                          <div className="form-group">
                            <label className="form-label" >
                              Chi phí(đ){` `}<span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="deliveryFeeByWeight"
                                rules={{
                                  required: "Vui lòng nhập thông tin",
                                }}
                                render={({ onChange, value, ref }) => (
                                  <NumericFormat
                                    className="form-control"
                                    getInputRef={ref}
                                    type="text"
                                    value={value}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={2}
                                    onValueChange={(val) => onChange(val.floatValue)}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="deliveryFeeByWeight"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>



                        <Col size="12">
                          <div className="form-group">
                            <label className="form-label" >
                              Ghi chú
                            </label>
                            <div className="form-control-wrap">
                              <textarea
                                rows={3}
                                className="form-control"
                                style={{ height: "unset" }}
                                name="note"
                                ref={register()}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col size="12" md={3}>
                          <div className="form-group">
                            <label className="form-label" >
                              Trạng thái đơn<span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="status"
                                rules={{
                                  required: "Vui lòng nhập thông tin",
                                }}
                                render={({ onChange, value, name, ref }) => (
                                  <RSelect
                                    ref={ref}
                                    name={name}
                                    options={BILL_STATUS_OPTIONS}
                                    value={
                                      BILL_STATUS_OPTIONS.find((c) => c.value === value) ||
                                      null
                                    }
                                    onChange={(val) => onChange(val.value)}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="status"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row className="g-3 ">
                        <Col size="3" className="mt-3">
                          <Button color="primary" type="button" className={`ml-2`} onClick={handleSubmit(onHandleSubmit)}>
                            <span>Lưu đơn hàng</span>
                          </Button>

                        </Col>

                      </Row>
                    </form>
                  </FormProvider>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default PnBillStaffMoneyFlow;
